const bookingBundleTypes = {
  FETCH_BUNDLES_LOADING: "FETCH_BUNDLES_LOADING",
  RESET_BUNDLES_LOADING: "RESET_BUNDLES_LOADING",
  FETCH_MY_BOOKING_BUNDLES: "FETCH_MY_BOOKING_BUNDLES",
  RESET_MY_BOOKING_BUNDLES: "RESET_MY_BOOKING_BUNDLES",
};

export default bookingBundleTypes;
